export default "__VITE_ASSET__BNubgSEw__"